// components/FormBuilder/ComponentTypes/Text/index.tsx

import React from 'react';
import { Card, Input, Space, Button } from 'antd';
import { DeleteOutlined, UpOutlined, DownOutlined, DragOutlined } from '@ant-design/icons';
import { SortableHandle } from 'react-sortable-hoc';
import { Typography } from 'antd';

export const FooterButton = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            title={'Footer Button'}
            // extra={
            //     <Space direction="horizontal">
            //         <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
            //     </Space>
            // }
        >
            {!collapsed && (
                <Input
                    style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                    }}
                    showCount
                    maxLength={80}
                    value={component?.label}
                    onChange={(e) => onChange({ ...component, label: e.target.value })}
                    placeholder="Button label"
                />
            )}
        </Card>
    );
};
